import PropTypes from 'prop-types';
import _ from 'lodash';

export const Mode = {
  CREATE: 'create',
  EDIT: 'edit',
  READ: 'read'
};

export const modePropType = PropTypes.oneOf(_.values(Mode));
